import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { style, useRaffles } from '../api';

import { RaffleLink } from './common/Link';

export const TrackSubmittedContestsList = ({
  contestIds,
  style: styleProps,
  prefixText = 'submitted to',
}: {
  style?: CSSProperties;
  prefixText?: string | React.ReactNode;
  contestIds: number[];
}) => {
  const { data: contests = [] } = useRaffles(contestIds);
  if (!contests.length) {
    return null;
  }

  return (
    <ContestInfo style={styleProps}>
      {prefixText}{' '}
      {contests.map((contest, index) => (
        <>
          <RaffleLink raffle={contest}>
            <ContestTitle>{contest.title}</ContestTitle>
          </RaffleLink>
          {index === contests.length - 1 ? '' : ', '}
        </>
      ))}
    </ContestInfo>
  );
};

export const ContestInfo = styled.div`
  font-size: 12px;
  color: ${style.grey_dark_new};
`;
export const ContestTitle = styled.span`
  color: ${style.black_new};
`;
